import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import * as L from 'leaflet';

import { MapService } from '../../services/map.service';

@Component({
    selector: 'app-map',
    templateUrl: './map.component.html',
    styleUrls: ['./map.component.scss'],
})
export class MapComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() containerId: string = 'map';
    @Input() search: boolean = false;
    @Input() canClick: boolean = true;
    private map: L.Map;

    constructor(private mapService: MapService) {}
    ngOnInit(): void {}

    ngAfterViewInit(): void {
        this.map = this.mapService.initMap(
            this.containerId,
            {
                center: [4.711, -74.0721],
                zoom: 10,
            },
            this.search,
            this.canClick
        );
    }

    ngOnDestroy(): void {
        this.mapService.destroyMap(this.containerId);
    }
}
